export default __webpack_public_path__ + "static/media/search_icon.f65561c5.webp";